import { render, staticRenderFns } from "./EquipamentoCampoTemplate.vue?vue&type=template&id=c32b8c4a&scoped=true&"
import script from "./EquipamentoCampoTemplate.vue?vue&type=script&lang=js&"
export * from "./EquipamentoCampoTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoCampoTemplate.vue?vue&type=style&index=0&id=c32b8c4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32b8c4a",
  null
  
)

export default component.exports